import { OPPS_CLEAN_UP, RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_OPPORTUNITIES_FAILURE, FETCH_OPPORTUNITIES_REQUEST, FETCH_OPPORTUNITIES_SUCCESS } from "../../actions/opportunities/opportunitesActions";

  const initialState = {
    opportunitesLoading: false,
    opportunitesData: [],
    opportunitesError: null,
  };
  
  const opportunitiesReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_OPPORTUNITIES_REQUEST:
        return { ...state, opportunitesLoading: true , payload: action.payload};
      case FETCH_OPPORTUNITIES_SUCCESS:
        return { ...state, opportunitesLoading: false, opportunitesData: action.payload };
      case "UPDATE_BOOKMARK_SUCCESS":
        return {
        ...state,
        opportunitesData: state.opportunitesData.map(item =>
          item._id === action.payload.oppId
            ? { ...item, is_bookmarked: action.payload.data }
            : item
        )
      }; 
      case FETCH_OPPORTUNITIES_FAILURE:
        return { ...state, opportunitesLoading: false, opportunitesError: action.payload };
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
        return initialState  
        
      case OPPS_CLEAN_UP:
        return initialState           
      default:
        return state;
    }
  };
  
  export default opportunitiesReducer;
  